import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBillOfLading extends Layout {
    panelContactInfo: Panel;
    panelCustomerShipper: Panel;
    panelInputs: Panel;
    panelPdf: Panel;
    panelSMC3BOL: Panel;
    panelSpacer: Panel;
    panelSwitchButtons: Panel;
    sourceSendBillOfLading: DataSource;
    switchLookupType: Switch;
    switchSMC3BOL: Switch;
    textboxContactName: Textbox;
    textboxCustomer: Textbox;
    textboxEmail: Textbox;
    textboxShipper: Textbox;
    textboxSubject: Textbox;
}
